import { ActivityTone, type LastActivityDto } from '@signalvote/shared';
import { cn } from '@/lib/utils';
import { daysAgo } from './activityDay';

// Status colour only for a real state: a warning is owed, a success settled, an error a no.
const TONE: Record<ActivityTone, string> = {
  [ActivityTone.Muted]: 'text-muted-foreground',
  [ActivityTone.Good]: 'text-success',
  [ActivityTone.Warn]: 'text-warning',
  [ActivityTone.Bad]: 'text-destructive',
};

/** A person's last activity on two lines: what happened, then its campaign-local day ("today", "3d ago"). */
export function LastActivityCell({ activity, today }: { activity: LastActivityDto; today: string }) {
  return (
    <span data-testid="last-activity" className="block whitespace-nowrap">
      <span className={cn('block truncate text-[13px]', TONE[activity.tone])}>{activity.label}</span>
      {activity.on && <span className="block truncate text-xs text-muted-foreground">{daysAgo(activity.on, today)}</span>}
    </span>
  );
}
